// extracted by mini-css-extract-plugin
export default {"modal":"EgresosOrdena_modal__5WpKW","nombre":"EgresosOrdena_nombre__ssdCu","botok":"EgresosOrdena_botok__Exdfg","contCheckboxes":"EgresosOrdena_contCheckboxes__TFSda"};